import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';
import { storage, db } from '../../config/firebase';

export const uploadGeneratedVideo = async (
  orderId: string,
  file: File
): Promise<string> => {
  try {
    // Create a reference to the storage location
    const storageRef = ref(storage, `generated-videos/${orderId}/${file.name}`);
    
    // Upload the file
    await uploadBytes(storageRef, file);
    
    // Get the download URL
    const downloadURL = await getDownloadURL(storageRef);
    
    // Update the order in Firestore
    const orderRef = doc(db, 'orders', orderId);
    await updateDoc(orderRef, {
      generatedVideoUrl: downloadURL,
      status: 'completed',
      updatedAt: new Date()
    });
    
    return downloadURL;
  } catch (error) {
    console.error('Error uploading generated video:', error);
    throw new Error('Failed to upload generated video');
  }
};